import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_UserCalendar = _resolveComponent("UserCalendar")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_ossCompanySelector = _resolveComponent("ossCompanySelector")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_select_user = _resolveComponent("select-user")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialog) = $event)),
        "max-width": _ctx.$vuetify.display.mobile ? 'auto' : '900px',
        title: 'Ajouter une tâche',
        "previous-display": _ctx.windowStep !== 'default' && _ctx.windowStep !== 'taskHistory',
        validDisabled: !_ctx.isValid,
        onValid: _cache[10] || (_cache[10] = ($event: any) => (_ctx.valid())),
        onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.close())),
        onPrevious: _cache[12] || (_cache[12] = ($event: any) => (_ctx.previous()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              (_ctx.windowStep !== 'createTask' && _ctx.windowStep !== 'usersChoice')
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12",
                    class: "d-flex align-center justify-end flex-shrink-1 flex-grow-0 pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_toggle, {
                        modelValue: _ctx.windowStep,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.windowStep) = $event)),
                        rounded: "",
                        dense: "",
                        color: "secondary",
                        class: "pr-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            value: 'default',
                            icon: "$fa-calendar"
                          }),
                          _createVNode(_component_v_btn, {
                            size: "small",
                            value: 'taskHistory',
                            icon: "$fa-history"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {
                            _ctx.windowStep = 'createTask';
                            _ctx.emptyTask();
                        }),
                        rounded: "",
                        elevation: "0",
                        color: "primary",
                        class: "pl-2",
                        dark: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _cache[14] || (_cache[14] = _createTextVNode(" Créer ")),
                          _createVNode(_component_v_icon, { right: "" }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("$add")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window, {
                    modelValue: _ctx.windowStep,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.windowStep) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window_item, { value: 'default' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserCalendar)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: 'createTask' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_form, {
                            modelValue: _ctx.taskValid,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.taskValid) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex justify-center align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex pa-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.task.title,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.task.title) = $event)),
                                        label: "Titre",
                                        outlined: "",
                                        "hide-details": "",
                                        rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                        density: "compact"
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex pa-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ossCompanySelector, {
                                        modelValue: _ctx.task.company,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.task.company) = $event)),
                                        items: _ctx.allAvailableCompanies,
                                        selectClass: 'oss-dark',
                                        chipMaxLength: 9
                                      }, null, 8, ["modelValue", "items"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex pa-1",
                                    cols: "8"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        label: "Choix Collaborateur",
                                        onClick: _ctx.openUsersChoice,
                                        readonly: "",
                                        outlined: "",
                                        rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                        "model-value": _ctx.selectedUsersFromComponent,
                                        density: "compact"
                                      }, null, 8, ["onClick", "rules", "model-value"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex pa-1",
                                    cols: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_date_picker_filled, {
                                        modelValue: _ctx.task.dueDate,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.task.dueDate) = $event)),
                                        label: 'Échéance',
                                        textFieldReadOnly: false,
                                        rules: [(v) => !!v || _ctx.$t('settings.itemRequired')]
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex pa-1",
                                    cols: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.task.description,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.task.description) = $event)),
                                        label: "Description",
                                        outlined: "",
                                        clearable: "",
                                        rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                        density: "compact"
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.tasks)
                        ? (_openBlock(), _createBlock(_component_v_window_item, {
                            key: 0,
                            value: 'taskHistory'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "pt-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_data_table, {
                                        headers: _ctx.tasksTableHeaders,
                                        items: _ctx.tasks,
                                        itemLength: _ctx.tasksLength,
                                        "show-select": true,
                                        "x-dense": true,
                                        striped: true,
                                        "table-hover": true,
                                        "fixed-footer": true,
                                        "fixed-header": true,
                                        "checkbox-color": "primary"
                                      }, {
                                        "item.userTaskFrom": _withCtx(({ item }) => [
                                          _createTextVNode(_toDisplayString(_ctx.formatUserTaskFrom(item.userTaskFrom)), 1)
                                        ]),
                                        "item.selectedUsers": _withCtx(({ item }) => [
                                          _createTextVNode(_toDisplayString(_ctx.formatSelectedUsers(item.selectedUsers)), 1)
                                        ]),
                                        "item.dueDate": _withCtx(({ item }) => [
                                          _createTextVNode(_toDisplayString(_ctx.formatDate(item.dueDate)), 1)
                                        ]),
                                        "item.company": _withCtx(({ item }) => [
                                          _createTextVNode(_toDisplayString(_ctx.formatCompany(item.company)), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["headers", "items", "itemLength"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_window_item, { value: 'usersChoice' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "d-flex align-center justify-end flex-shrink-1 flex-grow-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_select_user, {
                                class: "px-1",
                                modelValue: _ctx.selectedUsers,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedUsers) = $event)),
                                companyId: _ctx.companyId,
                                type: 'NATURAL_PERSON',
                                multiple: true
                              }, null, 8, ["modelValue", "companyId"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "previous-display", "validDisabled"])
    ]),
    _: 1
  }))
}